export default __webpack_public_path__ + "static/media/Gym.8f8da92c.jpg";